import * as React from 'react';
import { Icon, SvgIcon } from '@mui/material';
import { ReactComponent as Innospec } from '../Img/Innospec.svg';

// Custom SVG Icon Component
const InnospecIcon = (props: any) => {
    return (
        <SvgIcon
            {...props}
            viewBox="0 0 342.56 71.6" // Use the viewBox from your SVG file
            component={Innospec}
            sx={{
              width: 'auto', // Let the height determine the width to maintain aspect ratio
              height: 40, // Default height
              ...props.sx, // Allow overriding via props
            }}
        />
    );
};

export default InnospecIcon;